// DirtyMoney storefront on Shopify: cart drawer on the Ajax Cart API, bundle picker, gallery, case files, review slider.
// Product keys and variant ids come from window.DM.products (layout/dm.liquid).
const P = window.DM.products;
const ROOT = window.DM.root || "/";
const keyOf = {};
Object.entries(P).forEach(([k, p]) => (keyOf[p.id] = k));

// --- Cart rules: one goal, one offer -----------------------------------------
const FREE_SHIP = 35;            // the only progress bar in the cart
const GIFT_WITH = "box";         // the Boardroom Box comes with a free Desk Stand (automatic discount covers it)
const UPGRADES = [
  { from: "pack1", to: "pack2", text: "Make it 2 packs. Doubles are for trading." },
  { from: "pack2", to: "pack3", text: "Make it 3 packs. Free shipping and 3 shots at the Black Card." },
];
const ADDONS = ["envelope", "stand", "binder", "custom"]; // if no pack upgrade applies, the first one not in the cart is offered
const ORDER = ["pack1", "pack2", "pack3", "box", "envelope", "binder", "custom", "stand"]; // cart line order
const EXTRAS = ["protect", "priority"]; // tick boxes above Checkout
// ---------------------------------------------------------------------------

const eur = (n) => (n < 0 ? "−" : "") + "€" + Math.abs(n).toFixed(2).replace(".", ",").replace(",00", "");
const cents = (c) => eur(c / 100);
const GIFT_KEY = "dm_gift"; // "auto" = we added the stand, "declined" = shopper removed it

let cart = { items: [], item_count: 0, total_price: 0, total_discount: 0 };
const qty = (key) => cart.items.filter((i) => i.variant_id === P[key].id).reduce((a, i) => a + i.quantity, 0);
const isExtra = (i) => EXTRAS.includes(keyOf[i.variant_id]);
// what counts towards free shipping: everything the shopper pays for except the shipping extras
const spend = () => cart.items.filter((i) => !isExtra(i)).reduce((a, i) => a + i.final_line_price, 0) / 100;

async function post(path, body) {
  const r = await fetch(ROOT + path, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
  return r.json();
}
async function load() {
  cart = await (await fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } })).json();
}
async function setLine(lineKey, quantity) {
  await post("cart/change.js", { id: lineKey, quantity });
}
async function addKeys(keys) {
  await post("cart/add.js", { items: keys.map((k) => ({ id: P[k].id, quantity: 1 })) });
}

// keeps the free Desk Stand in step with the Boardroom Box, then redraws
async function sync() {
  await load();
  const giftOn = qty(GIFT_WITH) > 0;
  let state = null;
  try { state = localStorage.getItem(GIFT_KEY); } catch (e) {}
  const stand = cart.items.find((i) => keyOf[i.variant_id] === "stand");
  if (giftOn && !stand && state !== "declined") {
    await addKeys(["stand"]);
    try { localStorage.setItem(GIFT_KEY, "auto"); } catch (e) {}
    await load();
  } else if (!giftOn && state) {
    if (state === "auto" && stand) { await setLine(stand.key, stand.quantity - 1); await load(); }
    try { localStorage.removeItem(GIFT_KEY); } catch (e) {}
  }
  render();
}

async function add(key) { if (P[key]) { await addKeys([key]); await sync(); } }
async function change(lineKey, quantity) {
  const line = cart.items.find((i) => i.key === lineKey);
  if (line && keyOf[line.variant_id] === "stand" && quantity < line.quantity) {
    try { if (localStorage.getItem(GIFT_KEY) === "auto") localStorage.setItem(GIFT_KEY, "declined"); } catch (e) {}
  }
  await setLine(lineKey, Math.max(0, quantity));
  await sync();
}
async function swap(from, to) {
  const line = cart.items.find((i) => i.variant_id === P[from].id);
  if (!line) return;
  await setLine(line.key, line.quantity - 1);
  await addKeys([to]);
  await sync();
}

const drawer = document.createElement("div");
drawer.hidden = true;
document.body.appendChild(drawer);
function open() { drawer.hidden = false; render(); drawer.querySelector(".drawer header button").focus(); }
function close() { drawer.hidden = true; }

function rewardsHtml(sub) {
  const pct = Math.min(100, (sub / FREE_SHIP) * 100);
  const msg = sub < FREE_SHIP ? `Add <b>${eur(FREE_SHIP - sub)}</b> for <b>free shipping</b>.` : "<b>✓ You've got free shipping.</b>";
  return `<div class="ship"><span>${msg}</span><div class="bar"><i style="width:${pct}%"></i></div></div>`;
}

function render() {
  document.querySelectorAll("[data-count]").forEach((el) => (el.textContent = cart.items.filter((i) => !isExtra(i)).reduce((a, i) => a + i.quantity, 0)));
  const has = cart.item_count > 0;
  const rank = (i) => { const r = ORDER.indexOf(keyOf[i.variant_id]); return r < 0 ? 99 : r; };

  const lines = cart.items.filter((i) => !isExtra(i)).sort((x, y) => rank(x) - rank(y)).map((i) => {
    const p = P[keyOf[i.variant_id]];
    const name = p ? p.name : i.product_title;
    const free = i.final_line_price === 0;
    return `<div class="line${free ? " gift" : ""}"><img src="${p ? p.img : i.image}" alt=""><div><b>${name}</b>${free ? "<br><small>Free gift</small>" : ""}<br><span class="qty"><button data-line="${i.key}" data-q="${i.quantity - 1}" aria-label="Remove one ${name}">−</button>${i.quantity}<button data-line="${i.key}" data-q="${i.quantity + 1}" aria-label="Add one ${name}">+</button></span></div><span>${free ? "FREE" : cents(i.final_line_price)}</span></div>`;
  }).join("");

  // exactly one offer: a pack upgrade if there is one, otherwise a single add-on
  const up = UPGRADES.find((u) => qty(u.from) && !qty(u.to));
  const rec = has && !up ? ADDONS.find((id) => !qty(id)) : null;
  const offer = up
    ? `<div class="upgrade"><div><b>${up.text}</b><br>Only ${eur(P[up.to].price - P[up.from].price)} more.</div><button class="btn small gold" data-swap="${up.from}:${up.to}">Upgrade</button></div>`
    : rec
      ? `<div class="offer"><img src="${P[rec].img}" alt=""><div><b>${P[rec].pitch}</b><br>${P[rec].name}</div><button class="btn small" data-rec="${rec}">Add · ${eur(P[rec].price)}</button></div>`
      : "";

  const extras = has
    ? `<div class="extras">${EXTRAS.map((id) => `<label class="extra" title="${P[id].pitch}"><input type="checkbox" data-extra="${id}" ${qty(id) ? "checked" : ""}><span><b>${P[id].name}</b></span><span>+${eur(P[id].price)}</span></label>`).join("")}</div>`
    : "";
  const checkout = has ? `<a class="btn gold block" href="${ROOT}checkout">Checkout</a>` : `<button class="btn gold block" disabled>Checkout</button>`;
  drawer.innerHTML = `<div class="scrim" data-close></div>
  <aside class="drawer" role="dialog" aria-label="Cart"><header><h2>Your haul</h2><button data-close>Close</button></header>
    ${rewardsHtml(spend())}
    <div class="lines">${lines || '<p class="empty">Nothing here yet. Not even a shell company.</p>'}${offer}</div>
    <footer>${extras}<div class="total"><span>Subtotal</span><span>${cents(cart.total_price)}</span></div>
    ${checkout}
    <p class="note">Shipping is calculated at checkout. 30-day guarantee.</p></footer></aside>`;
}

document.addEventListener("click", (e) => {
  const t = e.target.closest("[data-add],[data-rec],[data-line],[data-swap],[data-close],[data-open-cart]");
  if (!t) return;
  const d = t.dataset;
  if (d.add) add(d.add).then(open);
  else if (d.rec) add(d.rec);
  else if (d.line) change(d.line, +d.q);
  else if (d.swap) swap(...d.swap.split(":"));
  else if ("close" in d) close();
  else if ("openCart" in d) open();
});
document.addEventListener("change", (e) => {
  const id = e.target.dataset && e.target.dataset.extra;
  if (!id) return;
  const line = cart.items.find((i) => i.variant_id === P[id].id);
  if (e.target.checked) add(id);
  else if (line) change(line.key, 0);
});
document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });

// PDP buy box
const form = document.getElementById("buy-form");
if (form) {
  const label = document.querySelectorAll("[data-buy-label]");
  const update = () => {
    const tier = form.querySelector('input[name="tier"]:checked').value;
    let sum = P[tier].price;
    form.querySelectorAll('input[name="addon"]:checked').forEach((a) => (sum += P[a.value].price));
    label.forEach((el) => (el.textContent = "Add to cart · " + eur(sum)));
  };
  form.addEventListener("change", update);
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const keys = [form.querySelector('input[name="tier"]:checked').value];
    form.querySelectorAll('input[name="addon"]:checked').forEach((a) => keys.push(a.value));
    await addKeys(keys);
    await sync();
    open();
  });
  update();
}

// gallery + case files share one tab pattern
document.querySelectorAll("[data-tabs]").forEach((group) => {
  group.addEventListener("click", (e) => {
    const b = e.target.closest("button");
    if (!b) return;
    group.querySelectorAll("button").forEach((x) => x.setAttribute("aria-selected", x === b));
    const vid = group.parentElement.querySelector("video.main");
    if (vid) {
      const img = document.getElementById(group.dataset.tabs);
      const on = !!b.dataset.video;
      vid.hidden = !on; img.hidden = on;
      if (on) vid.play().catch(() => {}); else vid.pause();
    }
    if (b.dataset.src) document.getElementById(group.dataset.tabs).src = b.dataset.src;
    if (b.dataset.panel) document.querySelectorAll(`[data-group="${group.dataset.tabs}"]`).forEach((p) => (p.hidden = p.id !== b.dataset.panel));
  });
});

// review slider: arrows, swipe (native scroll-snap) and a slow auto-advance that stops once the visitor takes over
document.querySelectorAll("[data-slider]").forEach((track) => {
  const step = () => (track.querySelector(".review").offsetWidth + 24);
  const go = (dir) => {
    const end = track.scrollWidth - track.clientWidth - 4;
    if (dir > 0 && track.scrollLeft >= end) track.scrollTo({ left: 0 });
    else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: end });
    else track.scrollBy({ left: dir * step() });
  };
  let auto = setInterval(() => go(1), 4000);
  const stop = () => clearInterval(auto);
  track.closest("section").querySelectorAll("[data-slide]").forEach((b) => b.addEventListener("click", () => { stop(); go(+b.dataset.slide); }));
  ["pointerdown", "wheel", "touchstart"].forEach((e) => track.addEventListener(e, stop, { passive: true }));
  track.addEventListener("mouseenter", stop);
});

sync();
